// extracted by mini-css-extract-plugin
module.exports = {"line":"Mirron_line__3oFZ0","mobileAppWrapper":"Mirron_mobileAppWrapper__2o6z1"};